import { gql } from '@apollo/client'
import { chatMessagesFragment } from './graphql'
import type { ChatMessage } from '@ztechapps/common.contract'
import { useSubscription, type UseSubscriptionProps } from '@ztechapps/common.hook'

const defaultQuery = gql`
  ${chatMessagesFragment}
  subscription createdChatMessage($filter: JSON) {
    createdChatMessage(filter: $filter) {
      ...chatMessagesFragmet
    }
  }
`

export const useChatMessageSubscription = (
  { query, onData, filter = {} } = {} as UseSubscriptionProps<{ createdChatMessage: ChatMessage }>
) => {
  query ??= defaultQuery

  return useSubscription({ query, filter, onData })
}
